import * as Dialog from "@radix-ui/react-dialog";
import { useState, useEffect } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

type MCSecurityConfirmModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  actionLabel: string;
  confirmationPhrase: string;
  onConfirm: () => Promise<void> | void;
  confirming?: boolean;
};

export function MCSecurityConfirmModal({
  open,
  onOpenChange,
  actionLabel,
  confirmationPhrase,
  onConfirm,
  confirming,
}: MCSecurityConfirmModalProps) {
  const [value, setValue] = useState("");
  const disabled = value.trim().toUpperCase() !== confirmationPhrase.toUpperCase();

  useEffect(() => {
    if (!open) {
      setValue("");
    }
  }, [open]);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-full max-w-lg -translate-x-1/2 -translate-y-1/2 rounded-2xl border border-red-400/40 bg-background p-6 shadow-2xl">
          <Dialog.Title className="text-lg font-semibold text-red-200">
            Confirm {actionLabel.toLowerCase()}
          </Dialog.Title>
          <Dialog.Description className="mt-1 text-sm text-red-100/80">
            Type <span className="font-mono text-red-100">{confirmationPhrase}</span> to authorize this action. This
            injects the required confirmation header.
          </Dialog.Description>
          <div className="mt-4 space-y-2">
            <Input
              value={value}
              onChange={(event) => setValue(event.target.value)}
              placeholder={confirmationPhrase}
              className="bg-background/40 text-foreground"
            />
          </div>
          <div className="mt-6 flex justify-end gap-3">
            <Button variant="ghost" onClick={() => onOpenChange(false)} disabled={confirming}>
              Cancel
            </Button>
            <Button
              variant="destructive"
              disabled={disabled || confirming}
              onClick={() => {
                void onConfirm();
              }}
            >
              {confirming ? "Executing…" : "Confirm action"}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default MCSecurityConfirmModal;
